import Header from './components/Header';
import Hero from './components/Hero';
import MediaSection from './components/MediaSection';
import FeaturesSection from './components/FeaturesSection';
import CarouselSection from './components/CarouselSection';
import UpdatesSection from './components/UpdatesSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import AboutSection from './components/AboutSection';
import ContactSection from './components/ContactSection';
import RankingSection from './components/RankingSection';
import FAQSection from './components/FAQSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import CommentsSection from './components/CommentsSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-50">
      <Header />

      <main>
        <Hero />

        <MediaSection />

        <FeaturesSection />

        <CarouselSection />

        <UpdatesSection />

        <TopicsSection />

        <IndexSection />

        <AboutSection />

        <ContactSection />

        <RankingSection />

        <FAQSection />

        <AppSection />

        <CardsSection />

        <CommentsSection />
      </main>

      <Footer />
    </div>
  );
}